import React from 'react';
import styles from './Footer.module.css';
import logoDark from '../../logo-dark.svg';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleVideoCallClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/contact', { state: { scrollToCalendar: true } });
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerLeft}>
          {/* Logo */}
          <div className={styles.logoRow}>
            <img src={logoDark} alt="Appotype Logo" className={styles.logo} />
          </div>

          {/* Social Icons */}
          <div className={styles.socialIcons}>
            <a href="#"><i className="fa-brands fa-linkedin"></i></a>
            <a href="#"><i className="fa-brands fa-facebook"></i></a>
            <a href="#"><i className="fa-brands fa-x-twitter"></i></a>
          </div>

          {/* Address and Hours */}
          <div className={styles.infoColumns}>
            <div className={styles.address}>
              <p>
                <b>{t("footer.company")}</b><br />
                {t("footer.address")}<br />
                {t("footer.city")}<br />
                <span className={styles.details}>NIP: 525-288-06-93<br />
                  KRS: 0000927164</span>
              </p>
            </div>
            <div className={styles.hours}>
              <p>
                <b>{t("footer.workingHours")}</b><br />
                {t("footer.workingDays")}<br />
                {t("footer.workingTime")}<br />
                <span className={styles.details}>{t("footer.timeZone")}</span>
              </p>
            </div>
          </div>
        </div>

        <div className={styles.footerMiddle}></div>

        <div className={styles.footerRight}>
          {/* Navigation Columns */}
          <div className={styles.navColumn}>
            <h4>{t("footer.general")}</h4>
            <ul>
              <li><NavLink to="/">{t("footer.home")}</NavLink></li>
              <li><NavLink to="/realizacje">{t("footer.projects")}</NavLink></li>
              <li><NavLink to="/uslugi/medtech">{t("footer.services")}</NavLink></li>
              <li><NavLink to="/about">{t("footer.about")}</NavLink></li>
            </ul>
          </div>
          <div className={styles.navColumn}>
            <h4>{t("footer.services")}</h4>
            <ul>
              <li><NavLink to="/uslugi/medtech">Medtech</NavLink></li>
              <li><NavLink to="/uslugi/ai">Artificial Intelligence</NavLink></li>
              <li><NavLink to="/uslugi/enterprise">Enterprise</NavLink></li>
              <li><NavLink to="/uslugi/software-agency">Software Agency</NavLink></li>
            </ul>
          </div>
          <div className={styles.navColumn}>
            <h4>{t("nav.contact")}</h4>
            <ul>
              <li><a href="#" onClick={handleVideoCallClick}>{t("footer.videoCall")}</a></li>
              <li><NavLink to="/calculator">{t("footer.calculator")}</NavLink></li>
            </ul>
          </div>
          <div className={styles.navColumn}>
            <h4>{t("footer.legal")}</h4>
            <ul>
              <li><NavLink to="/privacy">{t("footer.privacy")}</NavLink></li>
              <li><NavLink to="/cookies">{t("footer.cookies")}</NavLink></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Disclaimer: Always at the bottom */}
      <p className={styles.disclaimerBottom}>
        {t("footer.copyright")}
      </p>
    </footer>
  );
};

export default Footer;
